module.exports = __webpack_public_path__ + "static/media/close-circle-filled.9678e099.svg";